import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

export default function BasicInfo({ basicInfo }) {
  const location = useLocation();

  const infoItems = [
    { name: 'City', key: 'city' },
    { name: 'State', key: 'state' },
    { name: 'English Proficiency', key: 'englishProficiency' },
  ];

  const [userParams, setUserParams] = useState(null);

  useEffect(() => {
    const userParams = location.state.userParams;
    setUserParams(userParams);
  }, []);

  if (!basicInfo) return null;

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
            Basic Info
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>User Id:</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.User?.id}</span>
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Email:</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.User?.email}</span>
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Mobile:</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.User?.phone}</span>
          </div>

          {infoItems.map((item, index) => (
            <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>{item.name}:</span>
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{basicInfo[item.key]}</span>
            </div>
          ))}
    </div>
  );
}
